// استيراد React والمكتبات المساعدة لإدارة الحالات والتأثيرات الجانبية
import { useEffect, useState } from 'react';
// استيراد دوال التنقل والموقع من React Router
import { useLocation, useNavigate, Link } from 'react-router-dom';
// استيراد مكتبة axios لإجراء طلبات HTTP
import axios from 'axios';
// استيراد مكتبة لإدارة الكوكيز
import Cookie from 'cookie-universal';
// استيراد رابط الـ API الأساسي ورابط استدعاء جوجل
import { baseURL, GOOGLE_CALL_BACK } from '../../../API/Api';
// استيراد سياق اللغة
import { useLanguage } from '../../../Context/LanguageContext';
// استيراد ملف الأنماط
import './GoogleCallBack.css';

// إنشاء كائن لإدارة الكوكيز
const cookieJar = Cookie();

// المكون الرئيسي لاستدعاء جوجل
export default function GoogleCallBack ()
{
    // استيراد دالة الترجمة واتجاه النص من سياق اللغة
    const { t, dir } = useLanguage();
    // الحصول على معلومات الموقع الحالي
    const location = useLocation();
    // دالة للتنقل بين الصفحات
    const navigate = useNavigate();
    // حالة لتحديد حالة المعالجة (تحميل أو خطأ)
    const [ status, setStatus ] = useState( 'loading' ); // 'loading' | 'error'

    // تأثير جانبي لإكمال عملية تسجيل الدخول عبر جوجل
    useEffect( () =>
    {
        // متغير للتحكم في تنفيذ العمليات بعد إلغاء تحميل المكون
        let active = true;

        // دالة غير متزامنة لإكمال تسجيل الدخول عبر جوجل
        async function completeGoogleLogin ()
        {
            try
            {
                // إرسال طلب GET لاستكمال المصادقة مع جوجل - استخدام معلمات البحث من URL
                const { data } = await axios.get( `${ baseURL }/${ GOOGLE_CALL_BACK }${ location.search }` );
                // التحقق من أن المكون لا زال نشطاً
                if ( !active ) return;

                // حفظ رمز المصادقة في الكوكيز
                cookieJar.set( 'ecommerce', data.token );
                // تحديد دور المستخدم من البيانات المسترجعة
                const role = data.user?.role;
                // تحديد وجهة التنقل بناءً على دور المستخدم
                const destination = role === '1995' ? 'users' : role === '1999' ? 'categories' : 'writer';
                // التنقل إلى لوحة التحكم المناسبة
                navigate( `/dashboard/${ destination }`, { replace: true } );
            } catch ( err )
            {
                // طباعة الخطأ في وحدة التحكم للمساعدة في التصحيح
                console.log( err );
                // تحديث الحالة إلى خطأ إذا كان المكون لا زال نشطاً
                if ( active ) setStatus( 'error' );
            }
        }

        // استدعاء دالة إكمال تسجيل الدخول
        completeGoogleLogin();
        // دالة تنظيف لتحديث حالة النشاط عند إلغاء تحميل المكون
        return () => { active = false; };
    }, [ location.search, navigate ] ); // إعادة التشغيل عند تغيير معلمات البحث أو دالة التنقل

    // عرض واجهة معالجة استدعاء جوجل
    return (
        <div className="callback-page" dir={ dir }> {/* تطبيق اتجاه النص حسب اللغة */ }
            <div className="callback-card"> {/* بطاقة المعالجة */ }
                { status === 'loading' ? ( // إذا كانت الحالة تحميل
                    <>
                        {/* عرض حلقة تحميل */ }
                        <span className="callback-ring" aria-hidden="true" />
                        <h2>{ t( 'auth.googleLoadingTitle' ) }</h2> {/* عنوان التحميل */ }
                        <p>{ t( 'auth.googleLoadingDesc' ) }</p> {/* وصف التحميل */ }
                    </>
                ) : ( // إذا كانت الحالة خطأ
                    <>
                        {/* عرض علامة خطأ */ }
                        <span className="callback-x" aria-hidden="true">!</span>
                        <h2>{ t( 'auth.googleErrorTitle' ) }</h2> {/* عنوان الخطأ */ }
                        <p>{ t( 'auth.googleErrorDesc' ) }</p> {/* وصف الخطأ */ }
                        {/* رابط للعودة إلى صفحة المصادقة */ }
                        <Link to="/auth" className="callback-btn">{ t( 'auth.backToLogin' ) }</Link>
                    </>
                ) }
            </div>
        </div>
    );
}